// extracted by mini-css-extract-plugin
module.exports = {"container":"Terms_container__2H5dG","box":"Terms_box__OAqUl","topHeader":"Terms_topHeader__z-Q6u","backIcon":"Terms_backIcon__26P9j"};